module.exports = __webpack_public_path__ + "static/ppp-recipe-photo-collage.c0ed762c.png";